export default "__VITE_ASSET__7e1640a2__"